export const SCOPE = 'FLOW';
export const INIT = 'INIT';
export const STEP = 'STEP';
export const TRANSITION = 'TRANSITION';
export const FINISH = 'FINISH';
